const storageKey = 'checkoutOrderId';

export const cartIdStore = {
  get: () => localStorage.getItem(storageKey),
  set: (orderId: string) => localStorage.setItem(storageKey, orderId),
  remove: () => localStorage.removeItem(storageKey),
};
